import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import PageLayout from 'common/Layout/Page/PageLayout'
import TabPanel from 'common/TabPanel/TabPanel'
import { ColorBoxContent } from 'common/ui/colorBox'

import SidenavButton from '../pages/Orders/Vendor/ManageOrders/components/SidenavButton'

let toggledWarningFromPrevLocation = false

interface LocationState {
  reason?: string | undefined
}

// Generic component for tabbed pages
export default function TabbedPage(props: ITabbedPageProps) {
  const { subTabs, pageHeader, tabPanels } = props

  // reads the redirect error and toasts it to the client
  const location = useLocation()
  const state = location.state as LocationState
  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  const [sidebarTabValue, setSideBarTabValue] = useState(0)

  const sidebarVariantPicker = (allocatedNum) =>
    allocatedNum === sidebarTabValue ? 'primary' : 'tertiary'

  return (
    <PageLayout header={pageHeader}>
      <Grid container wrap='nowrap' spacing={2}>
        <Grid item xs={3}>
          <ColorBoxContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                gap: '10px'
              }}
            >
              {subTabs.map((subtab, index) => {
                return (
                  <SidenavButton
                    key={`${subtab}-${index}`}
                    onClick={(num) => setSideBarTabValue(num)}
                    value={index}
                    variant={sidebarVariantPicker(index)}
                    {...subtab}
                  />
                )
              })}
            </Box>
          </ColorBoxContent>
        </Grid>

        <Grid item xs={true}>
          {tabPanels.map((tabPanel, index) => (
            <TabPanel key={tabPanel.key} value={sidebarTabValue} index={index}>
              {tabPanel.element}
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </PageLayout>
  )
}

interface ITabbedPageProps {
  pageHeader: string
  subTabs: { label: string; icon: JSX.Element }[]
  tabPanels: { key: string; element: JSX.Element }[]
}
